export const UPLOAD_IMAGE_REQUEST = "UPLOAD_IMAGE_REQUEST";
export const UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS";
export const UPLOAD_IMAGE_FAIL = "UPLOAD_IMAGE_FAIL";
export const UPLOAD_IMAGE_RESET = "UPLOAD_IMAGE_RESET";

export const UPLOAD_DELETE_REQUEST = "UPLOAD_DELETE_REQUEST";
export const UPLOAD_DELETE_SUCCESS = "UPLOAD_DELETE_SUCCESS";
export const UPLOAD_DELETE_FAIL = "UPLOAD_DELETE_FAIL";
